import { defineComponent as _defineComponent } from 'vue'
import FieldNote from "Src/js/components/FieldNote.vue";
import Icon from "Src/js/components/Icon.vue";
import { useSlots } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorBanner',
  props: {
    errorMessage: null
  },
  setup(__props: any) {

const props = __props as {
	errorMessage?: string;
}



const slots = useSlots();
const hasSlot = slots['default'];

return { __sfc: true,props, slots, hasSlot, FieldNote, Icon }
}

})